import React from 'react';
import './AddAgency.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const AddAgency = () => {
return( 
<div>
    <SideMenuBar></SideMenuBar>
        
    <div class="content">
          <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Add Agency</h3>  
          </div>

          <div className='row4_AddAgency'>
            <input className='siteName_input_AddAgency' placeholder='Enter Site Name'></input>
          </div>

          <div class="row5_AddAgency">
            <div class="row5_column1_AddAgency">
              <p>Agency Name</p>
              <input className='input_AddAgency' placeholder='Enter Agency Name'></input>

              <p>Address</p>
              <textarea className='address_input_AddAgency' placeholder='Enter Address'></textarea><br/>

            </div>
  
            <div class="row5_column2_AddAgency">
              <p>Organization</p>
              <input className='input_AddAgency' placeholder='Enter Organization'></input>

              <p>Phone No.</p>
              <input className='input_AddAgency' placeholder='Enter Phone No.'></input>

              <p>Email ID</p>
              <input className='input_AddAgency' placeholder='Enter Email ID'></input>

              <button className='add_btn_input_AddAgency'>Add</button>
            </div>
          </div>

    </div>
</div>
 )
}

export default AddAgency;